import React from 'react';

import { WorkInProgressPage } from '../../../features/WorkInProgressPage/WorkInProgressPage';

export const Spam: React.VFC = () => {
    return <WorkInProgressPage project='Spam' />;
};
